import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";

export class DepositFormSettingModel extends EntityBase {
  public HasServicesAmount: boolean;
  public HasDepositAmount: boolean;
  public HasNumberOfCooks: boolean;
  public HasDeliveryType: boolean;
  public HasNumberOfPeople: boolean;
  public HasClearType: boolean;
  public FoodPricePerson: boolean;
  constructor() {
    super();
    this.HasServicesAmount = true;
    this.HasDepositAmount = true;
    this.HasNumberOfCooks = true;
    this.HasDeliveryType = true;
    this.HasNumberOfPeople = true;
    this.HasClearType = true;
    this.FoodPricePerson = true;
  }
}
